import {
  HydratedAgent,
  useDeleteAgent as useDeleteAgentMutation,
  useFavoriteAssets,
} from "@zapier/client";
import { AssetTypes, useNotification } from "@zapier/utils";
import { useTranslations } from "@zapier/i18n";

export function useDeleteAgent(
  agent: HydratedAgent | undefined,
  folderId?: string, // used for cache invalidation in mutations
) {
  const { mutate, isPending } = useDeleteAgentMutation({ folderId });
  const { createNotification } = useNotification();
  const t = useTranslations("agent-delete-modal");

  const { removeFromFavorites } = useFavoriteAssets();

  const deleteAgent = () => {
    if (!agent) {
      return;
    }

    mutate(
      { id: agent.id },
      {
        onSuccess: () => {
          createNotification({
            message: t("notifications.delete-success", {
              agentName: agent.name,
            }),
            type: "success",
          });

          removeFromFavorites(agent.id, AssetTypes.Agent);
        },
        onError: () => {
          createNotification({
            message: t("notifications.delete-error", {
              agentName: agent.name,
            }),
            type: "error",
          });
        },
      },
    );
  };

  return { deleteAgent, isPending };
}
